import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BypassInformation, PigAccessory, PigAssociatedProduct, PigBulletin, PigComponent, PigQueryResult, ProductInformation, ReplacementPart } from '../../../models';

@Component({
  selector: 'app-pig-detail-modal',
  templateUrl: './pig-detail-modal.component.html',
  styleUrls: ['./pig-detail-modal.component.scss']
})
export class PigDetailModalComponent implements OnInit {
  specialConsiderationsIsCollapsed = true;

  @Input() item?: PigQueryResult;
  @Input() productInfo?: ProductInformation[];
  @Input() bypassInfo?: BypassInformation[];
  @Input() replacementParts?: ReplacementPart[];
  @Input() pigComponents?: PigComponent[];
  @Input() pigAccessories?: PigAccessory[];
  @Input() associatedProducts?: PigAssociatedProduct[];
  @Input() bulletins?: PigBulletin[];
  @Input() isLoadingDetail = false;
  @Input() isLoadingDwg = false;

  @Output() getCutSheet = new EventEmitter<number>();

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  toggleSpecialConsiderationsCollapse(): void {
    this.specialConsiderationsIsCollapsed = !this.specialConsiderationsIsCollapsed;
  }

}
